<template>
  <div>
    <v-row class="my-2 mx-4">
      <h1 class="text-left ">Payroll Particulars</h1>
    </v-row>
      <v-card class="mx-2 pa-3 " outlined >
        <v-row>
          <v-col cols="12" md="6">    
            <v-row class="my-1">
              <v-col cols="12" md="7" align-self="center">
                <h2 class="text-left mx-4">Earnings</h2>
              </v-col>
              <v-col cols="12" md="5" align-self="center">
                <v-btn
                  v-if="currentUser.privileges.canAddPayrollParticulars"
                  color="primary white--text"
                  class="mr-3 ml-5 mt-2 text-right"
                  @click = "AddItem('Earning')"
                  id="earning-particulars"
                >
                  Add Earning
                </v-btn>
              </v-col>
            </v-row>
            <v-data-table
              :headers="headers"
              :items="earnings"
              class="elevation-1"
              hide-default-footer
              disable-pagination
              id="earning-particular-table"
            >
              <template v-slot:item.actions="{ item }">
                <div v-if="currentUser.privileges.canEditPayrollParticulars || currentUser.privileges.canDeletePayrollParticulars">
                  <v-icon
                    small
                    v-if="currentUser.privileges.canEditPayrollParticulars"
                    class="mr-2"
                    @click="editItem(item, 'Earning')"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-tooltip bottom :disabled="item.is_editable" v-if="currentUser.privileges.canDeletePayrollParticulars">
                    <template v-slot:activator="{ on }">
                      <div v-on="on" class="d-inline-block">
                        <v-icon
                          small
                          :disabled="!item.is_editable"
                          @click="deleteCategory(item,'Earning')"
                        >
                          mdi-delete
                        </v-icon>
                      </div>
                    </template>
                    <span>This particular cannot be deleted as it is already allocated to payroll group(s).</span>

                  </v-tooltip>
                </div>
                <div v-else>
                  -
                </div>
              </template>
              
            </v-data-table>
          </v-col>
          <v-col cols="12" md="6">
            <v-row class="my-1">
              <v-col cols="12" md="6" align-self="center">
                <h2 class="text-left mx-4">Deductions</h2>
              </v-col>
              <v-col cols="12" md="6" align-self="center">
                <v-btn
                  v-if="currentUser.privileges.canAddPayrollParticulars"

                  color="primary white--text"
                  class="mt-2 text-right ml-8"
                  @click="AddItem('Deduction')"
                  id="deduction-particulars"
                >
                  Add Deduction
                </v-btn>
              </v-col>
            </v-row>
            <v-data-table
              :headers="headers"
              :items="deductions"
              class="elevation-1"
              hide-default-footer
              disable-pagination
              id="deduction-particular-table"
            >
              <template v-slot:item.actions="{ item }">
                <div v-if="currentUser.privileges.canEditPayrollParticulars || currentUser.privileges.canDeletePayrollParticulars">
                  <v-icon
                    small
                    v-if="currentUser.privileges.canEditPayrollParticulars"
                    class="mr-2"
                    @click="editItem(item,'Deduction')"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-tooltip bottom :disabled="item.is_editable" v-if="currentUser.privileges.canDeletePayrollParticulars">
                    <template v-slot:activator="{ on }">
                      <div v-on="on" class="d-inline-block">
                        <v-icon
                          small
                          :disabled="!item.is_editable"
                          @click="deleteCategory(item,'Deduction')"
                        >
                          mdi-delete
                        </v-icon>
                      </div>
                    </template>
                    <span>This cannot be deleted as it is already allocated to payroll group(s).</span>

                  </v-tooltip>
                </div>
                <div v-else>
                  -
                </div>

              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>

      <v-row justify="center">
        <ConfirmationDialog
          :title="addEditTitle"
          successText="Save"
          @successCallback="saveItem()"
          failureText="Cancel"
          @failureCallback="closeDialog"
          :visible="dialog"
        >
          <slot>
            <v-form ref="form">
              <v-text-field
                v-model="AddEditItem.title"
                class="rounded-input mx-5"
                outlined
                dense
                :rules="[rules.required]"
                placeholder="Title"
              />
              <v-text-field
                v-model="AddEditItem.code"
                class="rounded-input mx-5"
                outlined
                dense
                @keypress="AllowedChars"
                :rules="[rules.required]"
                placeholder="Code"
                maxlength = "4"
                counter
              />
            </v-form>
          </slot>
        </ConfirmationDialog>
      </v-row>

      <v-row justify="center">
        <ConfirmationDialog
          title="Are you sure you want to delete this item?"
          description="This particular might be associated with other payroll groups, are you sure you want to proceed?"
          successText="Ok"
          @successCallback="deleteItem()"
          failureText="Cancel"
          @failureCallback="closeDialogDelete"
          :visible="dialogDelete"
        >
        </ConfirmationDialog>
      </v-row>

      <v-snackbar v-model="snackbar.visible" timeout="5000" :color="snackbar.color" multi-line>
        {{ snackbar.message }}
        <template v-slot:action="{ attrs }">
          <v-btn dark text v-bind="attrs" @click="snackbar.visible = false">Close</v-btn>
        </template>
      </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ConfirmationDialog from "@components/widgets/dialogs/ConfirmationDialog";
import api from "@api/index";
import endpoints from "@api/repository";
import TourHelper from "@utils/tour_helper";



  export default {
    name: "PayrollParticulars",
    components: {
    ConfirmationDialog,
    },
    data: () => ({

      // Add edit dialog visibility
      dialog: false,

      // Title of add edit dialog
      addEditTitle: '',

      // Validation
      rules: {
        required: (v) => !!v || "Required",
      },

      // Temporary object to store form details
      AddEditItem: {
        title: '',
        code: '',
      },

      // To check if editing or adding
      is_editing: false,

      // To store the id of item being edited
      editedItemId: -1,

      // Visibility status of delete dialog
      dialogDelete: false,

      headers: [
        {
          text: 'Title',
          align: 'start',
          sortable: false,
          value: 'title',
        },
        { text: 'Code', value: 'code', align: 'start', sortable: false },
        { text: 'Actions', value: 'actions', align:'center', sortable: false },
      ],


      earnings: [],
      deductions: [],

      snackbar: {
        visible: false,
        message: "",
        color: "dark",
      },
    }),
    
    methods: {
      ...mapActions(["setLoading"]),

      handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Welcome to Payroll Particulars", description: "Add or Edit earnings and deductions types which are present in seperate tables", videoLink: "https://youtube.com"});
        steps.push({id: '2', description: "Select payslip group and month year from dropdowns to view payslip information.", el: '#approved-payslip-row'});
        steps.push({id: '3', description: "Add your Earning particulars by filling title and code.", position:'top' ,el: '#earning-particulars'});
        steps.push({id: '4', title: "Earning Payroll Particulars",description: "View and edit your Earning payroll particulars <br><br> <b>Note:</b>Edited particular may be affected in other pages.", el: '#earning-particular-table'});
        steps.push({id: '5', description: "Add your deduction particulars by filling title and code.", el: '#deduction-particulars'});
        steps.push({id: '6', title: "Deduction Payroll Particulars",description: "View and edit your Deduction payroll particulars <br><br> <b>Note:</b>Edited particular may be affected in other pages.", el: '#deduction-particular-table'});
        TourHelper.startTour(this, "payroll__particulars", steps);
    },

      // Validation
      AllowedChars ($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode<48)|| (keyCode>57 && keyCode<64) || (keyCode>90 && keyCode<97) || (keyCode>122)) { 
            $event.preventDefault();
        }
      },

      // Triggers on delete button click
      deleteCategory(item,category){
        this.addEditTitle = category;
        this.editedItemId = item.id;
        this.dialogDelete = true;
      },

      // Triggers on deleting finally from dialog
      async deleteItem(){
        let url = endpoints.getPayrollParticulars + `${this.editedItemId}/`;
        let response = await api.call(this.apiEssentials, url, api.Methods.DELETE);
        if(response) {
          this.earnings = [];
          this.deductions = [];
          this.getPayrollParticulars();
        }
        this.snackbar.message = "Item deleted successfully";
        this.snackbar.visible = true;
        this.closeDialogDelete();
      },

      // To close delete dialog
      closeDialogDelete(){
        this.dialogDelete = false;
        this.editedItemId = -1;
        this.addEditTitle = '';
      },

      // Triggers on clicking edit icon
      editItem(item,category){
        // To fill dialog fields already
        this.AddEditItem.title = item.title;
        this.AddEditItem.code = item.code;

        // For title of dialog
        this.addEditTitle = category;

        // To show edit status
        this.is_editing = true;

        this.dialog = true;

        // To get id of item being edited
        this.editedItemId = item.id;   
      },


      AddItem(category){
        this.addEditTitle = category;
        this.dialog = true;
      },

      validate(){
        if(!this.AddEditItem.title)
        {
          this.snackbar.color = "error";
          this.snackbar.message = "Title cannot be empty";
          this.snackbar.visible = true;
          return false
        }
        else if(!this.AddEditItem.code){
          this.snackbar.color = "error";
          this.snackbar.message = "Code cannot be empty";
          this.snackbar.visible = true;
          return false;
        }

        return true;
      },

      async saveItem(){

        var POST_BODY = { 
          "particular": {
            "title": this.AddEditItem.title,
            "particular_type": '',
            "code": this.AddEditItem.code,
          }
        };

        if(this.validate()){         
          if(this.addEditTitle == "Earning"){
            POST_BODY.particular.particular_type = 'E';
          }
          else{
            POST_BODY.particular.particular_type = 'D';
          }

          if(this.is_editing){
            POST_BODY.is_editing = true;
            POST_BODY.particular.id = this.editedItemId;
          }

          var response = await api.call(
            this.apiEssentials,
            endpoints.getPayrollParticulars,
            api.Methods.POST,
            POST_BODY
          );

          if(response && !this.is_editing){
            this.snackbar.color = "dark";
            this.snackbar.message = this.addEditTitle + " category added successfully";
            this.snackbar.visible = true;
          }
          else if(response && this.is_editing){
            this.snackbar.color = "dark";
            this.snackbar.message = this.addEditTitle + " category edited successfully";
            this.snackbar.visible = true;
          }

          this.earnings = [];
          this.deductions = [];
          this.getPayrollParticulars();
          if(response) {
            this.closeDialog();
          }
        }        
      },

      closeDialog(){
        this.$refs.form.reset();
        this.addEditTitle = '';
        this.editedItemId = -1;
        this.is_editing = false;
        this.dialog = false;
      },

      async getPayrollParticulars(){
          var response;
          var url = endpoints.getPayrollParticulars;
          response = await api.handleApi({
            apiEssentials: this.apiEssentials,
            url: url,
            responseVar: response,
          });
          if (response) {
            response.forEach(data => {
              if(data.particular_type == 'E'){
                this.earnings.push(data);
              }
              else{
                this.deductions.push(data);
              }
            })
          }
      },

      async handleApiErrors(err) {
        this.setLoading(false);
        console.log(err);
        if (err.response) {
          if (err.response.status == 409) {
            this.snackbar.message = err.response.data;
            this.snackbar.color = "error";
            this.snackbar.visible = true;
          }
        } else {
          this.snackbar.message = "Unable to process request";
          this.snackbar.color = "error";
          this.snackbar.visible = true;
        }
      },
    },

    created () {
      this.getPayrollParticulars();
      this.handleTour();
    },

    computed: {
      ...mapGetters(["currentUser", "accessToken", "isLoading"]),

        apiEssentials() {
          return {
            accessToken: this.accessToken,
            handleErrorsFunction: this.handleApiErrors,
            setLoading: this.setLoading,
          };
        },
    },

  }
</script>

<style scoped>

</style>